/* eslint-disable linebreak-style */
// weld data management
export const FETCH_WELD_DATA = '@@weld/fetch-weld-data';
export const SET_WELD_DATA = '@@weld/set-weld-data';
export const SET_WELD_DATA_FAILURE = '@@weld/set-weld-data-failure';
export const FETCH_WELD_PASSES = '@@weld/fetch-weld-passes';
export const SET_WELD_PASSES = '@@weld/set-weld-passes';
export const SET_WELD_PASSES_FAILURE = '@@weld/set-weld-passes-failure';
export const CLEAR_WELD_PASSES = '@@weld/clear-weld-passes';
export const FETCH_ZONE_VIEW = '@@weld/fetch-zone-view';
export const SET_ZONE_VIEW = '@@weld/set-zone-view';
export const SET_ZONE_VIEW_FAILURE = '@@weld/set-zone-view-failure';
export const CLEAR_ZONE_VIEW = '@@weld/clear-zone-view';
export const FETCH_TILT_VIEW = '@@weld/fetch-tilt-view';
export const SET_TILT_VIEW = '@@weld/set-tilt-view';
export const SET_TILT_VIEW_FAILURE = '@@weld/set-tilt-view-failure';
export const CLEAR_TILT_VIEW = '@@weld/clear-tilt-view';
export const FETCH_TILT_VIEW_DETAILS = '@@weld/fetch-tilt-view-details';
export const FETCH_PASS_VIEW_DETAILS = '@@weld/fetch-pass-view-details';
export const SET_PASS_VIEW_DETAILS = '@@weld/set-pass-view-details';
export const SET_PASS_VIEW_DETAILS_FAILURE = '@@weld/set-pass-view-details-failure';
export const CLEAR_PASS_VIEW_DETAILS = '@@weld/clear-pass-view-details';
export const FETCH_ZONE_VIEW_DETAILS = '@@weld/fetch-zone-view-details';
export const SET_ZONE_VIEW_DETAILS = '@@weld/set-zone-view-details';
export const SET_ZONE_VIEW_DETAILS_FAILURE = '@@weld/set-zone-view-details-failure';
export const CLEAR_ZONE_VIEW_DETAILS = '@@weld/clear-zone-view-details';
export const SET_CURRENT_PROJECT = '@@weld/set-current-project';
export const CLEAR_CURRENT_PROJECT = '@@weld/clear-current-project';
export const FETCH_PROJECTS = '@@weld/fetch-projects';
export const SET_PROJECTS = '@@weld/set-projects';
export const SET_PROJECTS_FAILURE = '@@weld/set-projects-failure';
export const SET_SELECTED_PROJECT = '@@weld/set-selected-project';

// Slog data management
export const FETCH_SLOGS_REQUEST = '@@weld/fetch-slogs-request';
export const FETCH_SLOGS_SUCCESS = '@@weld/fetch-slogs-success';
export const FETCH_SLOGS_FAILURE = '@@weld/fetch-slogs-failure';

// Report generation management
export const GENERATE_REPORT_REQUEST = '@@weld/generate-report-request';
export const GENERATE_REPORT_SUCCESS = '@@weld/generate-report-success';
export const GENERATE_REPORT_FAILURE = '@@weld/generate-report-failure';
export const CLEAR_REPORT_STATUS = '@@weld/clear-report-status';
export const CLEAR_WELD_DATA = '@@weld/clear-weld-data';

// Limits data management
export const FETCH_LIMITS_DATA = '@@weld/fetch-limits-data';
export const SET_LIMITS_DATA = '@@weld/set-limits-data';
export const SET_LIMITS_DATA_FAILURE = '@@weld/set-limits-data-failure';
export const CLEAR_LIMITS_DATA = '@@weld/clear-limits-data';

// Status configuration management
export const UPDATE_STATUS_CONFIGURATION = '@@weld/update-status-configuration';
export const UPDATE_STATUS_CONFIGURATION_SUCCESS = '@@weld/update-status-configuration-success';
export const UPDATE_STATUS_CONFIGURATION_FAILURE = '@@weld/update-status-configuration-failure';

// Clear all weld views data
export const CLEAR_ALL_WELD_VIEWS = '@@weld/clear-all-weld-views';

// Assign pipe to weld data management
export const ASSIGN_PIPE_TO_WELD = '@@weld/assign-pipe-to-weld';
export const ASSIGN_PIPE_TO_WELD_SUCCESS = '@@weld/assign-pipe-to-weld-success';
export const ASSIGN_PIPE_TO_WELD_FAILURE = '@@weld/assign-pipe-to-weld-failure';

// Assign job number to pipe data management
export const ASSIGN_JOB_NUMBER_TO_PIPE = '@@weld/assign-job-number-to-pipe';
export const ASSIGN_JOB_NUMBER_TO_PIPE_SUCCESS = '@@weld/assign-job-number-to-pipe-success';
export const ASSIGN_JOB_NUMBER_TO_PIPE_FAILURE = '@@weld/assign-job-number-to-pipe-failure';

// Update weld number data management
export const UPDATE_WELD_NUMBER = '@@weld/update-weld-number';
export const UPDATE_WELD_NUMBER_SUCCESS = '@@weld/update-weld-number-success';
export const UPDATE_WELD_NUMBER_FAILURE = '@@weld/update-weld-number-failure';

// Merge passes data management
export const MERGE_PASSES = '@@weld/merge-passes';
export const MERGE_PASSES_SUCCESS = '@@weld/merge-passes-success';
export const MERGE_PASSES_FAILURE = '@@weld/merge-passes-failure';
export const CLEAR_MERGE_PASSES_STATUS = '@@weld/clear-merge-passes-status';
export const CLEAR_RESTORE_MERGED_PASSES_STATUS = '@@weld/clear-restore-merged-passes-status'; 